import React, { Component } from 'react';
import CopyRight from './copyRight';

export default class Footer extends Component {
  render() {
    return '';
    //   <div className="footer">
    //     <div className="float-right">
    //         powered by <strong><a href="//xerioz.com/" target="_blank" className="color-black strong">XerioZ</a></strong>.
    //     </div>
    //     <CopyRight/>
    // </div>
  }
}
